import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "@env/environment.prod";
import { IOrganisation, LoginCustomisation } from "./interfaces";

@Injectable()
export class SharedService {
  public Organisation: BehaviorSubject<IOrganisation> = new BehaviorSubject<IOrganisation>(null);
  public loadedOrganisationByUrl: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public loginCustomisation: BehaviorSubject<LoginCustomisation> = new BehaviorSubject<LoginCustomisation>(null);

  public LogoImage: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public BackgroundImage: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public ButtonColor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public TextButtonColor: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public checkFirstLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public passwordExpireFirstLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  //  needed after login, before 2FA authentication
  public loggedUserId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public userAttemptedLogin: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public userAttemptedLoginUsername: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public userAttemptedLoginPassword: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public currentOrganisationId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public returnUrl: BehaviorSubject<any> = new BehaviorSubject<any>(environment.default_return_url);
  public errorMsg: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  public changeLoggedUserId(_input: string) {
    this.loggedUserId.next(_input);
  }

  public changeCurrentOrganisationId(_input: string | any) {
    this.currentOrganisationId.next(_input);
  }
  public changeUserAttemptedLoginUsername(_input: string) {
    this.userAttemptedLoginUsername.next(_input);
  }

  public changeUserAttemptedLoginPassword(_input: string | any) {
    this.userAttemptedLoginPassword.next(_input);
  }

  public changeUserAttemptedLogin(_input: string) {
    this.userAttemptedLogin.next(_input);
  }

  public changeReturnUrl(_input: string) {
    this.returnUrl.next(_input);
  }

  public setErrorMsg(_input: string | any) {
    this.errorMsg.next(_input);
  }

  public changeLoadedOrganisation(_input: boolean) {
    this.loadedOrganisationByUrl.next(_input);
  }

  public changeOrganisationObject(_organisation: IOrganisation | any) {
    this.Organisation.next(_organisation);
  }

  public changeLogoImage(_input: any) {
    this.LogoImage.next(_input);
  }

  public changeBackgroundImage(_input: any) {
    this.BackgroundImage.next(_input);
  }

  public storeFirstLoginForExpiryPassword(_input: boolean) {
    this.checkFirstLogin.next(_input);
  }

  public storeResetPasswordAfterExpire(_input: boolean) {
    this.passwordExpireFirstLogin.next(_input);
  }

  public changeLoginCustomisaiton(_loginCustomisation: LoginCustomisation | any) {
    this.loginCustomisation.next(_loginCustomisation);
    this.ButtonColor.next(_loginCustomisation.btnColor);
    this.TextButtonColor.next(_loginCustomisation.textBtnColor);
  }

  public resetLoginCustomisation() {
    this.loadedOrganisationByUrl.next(false);
    this.Organisation.next(null);
    this.loginCustomisation.next(null);
    this.ButtonColor.next(null);
    this.TextButtonColor.next(null);
    this.LogoImage.next(null);
    this.BackgroundImage.next(null);
  }
}
